import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { DeleteQuestionTextModal, NotQuestion } from 'src/config/config';
import { Text } from '@consta/uikit/Text';

// Styles
import styles from './styles.styl';
import cn from 'classnames/bind';
import { connect } from 'react-redux';
import { State } from 'src/redux/reducer';
import {
  allListQuestionIdSelector,
  allListQuestionLoadedSelector,
} from 'src/redux/features/questions/allListQuestions/selectors';
import {
  AllListQuestionDataEnt,
  AnswersData,
} from 'src/redux/features/questions/allListQuestions/types';
import { Loader } from '@consta/uikit/Loader';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { loadAllListQuestions } from 'src/redux/features/questions/allListQuestions/actions';
import { IconArrowDown } from '@consta/uikit/IconArrowDown';
import { IconDraggable } from '@consta/uikit/IconDraggable';
import { IconTrash } from '@consta/uikit/IconTrash';
import { IconEdit } from '@consta/uikit/IconEdit';
import { Button } from '@consta/uikit/Button';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { loadDeleteQuestion } from 'src/redux/features/questions/deleteQuestion/actions';
import { IconClose } from '@consta/uikit/IconClose';
import { Radio } from '@consta/uikit/Radio';
import { CloseModal } from '../CloseModal';
import { Modal } from '@consta/uikit/Modal';
import { addImagesIdle } from 'src/redux/features/surveys/addImages/actions';
import { deleteImageIdle } from 'src/redux/features/surveys/deleteImagesSurvey/actions';
import { locationNotApi } from 'src/utils/api';
import {
  QuestionTypeEnum,
  SurveyStatusEnum,
  SurveyTypeEnum,
} from 'src/utils/enum';
import { Checkbox } from '@consta/uikit/Checkbox';
import { TextField } from '@consta/uikit/TextField';
import { TestState } from 'src/redux/features/surveys/testData/types';
import { TitleCreateTestType } from 'src/redux/features/surveys/titleCreateTest/types';
import { ISurvey } from 'src/redux/features/surveys/allSurvey/types';
import { ChoiceGroup } from '@consta/uikit/ChoiceGroup';

const cx = cn.bind(styles);

export interface QuestionContentProps {
  className?: string;
  allListQuestion: AllListQuestionDataEnt[];
  isLoadingListQuestion: boolean;
  loadAllListQuestions: (id: number) => void;
  loadDeleteQuestion: (idSurvey: number, idQuestion: number) => void;
  setQuestion: (isQuest: boolean) => void;
  setEditQuestion: (item: AllListQuestionDataEnt) => void;
  addImagesIdle: () => void;
  deleteImageIdle: () => void;
  listQuestion: AllListQuestionDataEnt[];
  setListQuestion: (isItem: any) => void;
  setSave: (isSave: boolean) => void;
  testData: TestState;
  titleCreateTest: TitleCreateTestType;
  oneSurvey: ISurvey;
  id: string;
}

export interface ItemOpen {
  id: boolean;
}

const QuestionContent: React.FC<QuestionContentProps> = ({
  className,
  allListQuestion,
  isLoadingListQuestion,
  loadAllListQuestions,
  loadDeleteQuestion,
  setQuestion,
  setEditQuestion,
  addImagesIdle,
  deleteImageIdle,
  listQuestion,
  setListQuestion,
  setSave,
  testData,
  oneSurvey,
  id,
}) => {
  const [modalClose, setModalCLose] = useState(false);
  const [idDeleteQuestion, setIdDeleteQuestion] = useState(null);
  const [open, setOpen] = useState<ItemOpen | any>([]);

  useEffect(() => {
    if (isLoadingListQuestion) {
      setOpen(
        allListQuestion.reduce(
          (acc, item) => ({ ...acc, [item.id]: false }),
          {},
        ),
      );
    }
  }, [allListQuestion, isLoadingListQuestion]);

  useEffect(() => {
    loadAllListQuestions(Number(id));
  }, [id, loadAllListQuestions]);

  useEffect(() => {
    isLoadingListQuestion && setListQuestion(allListQuestion);
  }, [
    allListQuestion,
    isLoadingListQuestion,
    loadAllListQuestions,
    setListQuestion,
  ]);

  const handleDelete = useCallback(() => {
    loadDeleteQuestion(Number(id), idDeleteQuestion);
    setModalCLose(false);
  }, [id, idDeleteQuestion, loadDeleteQuestion]);

  const questSelect = (answer: AnswersData, type: number, rating: number) => {
    if (
      type === QuestionTypeEnum.SINGLE_SELECT ||
      type === QuestionTypeEnum.SINGLE_AND_SELF
    ) {
      return (
        <div className={cx('QuestionContent__radio')}>
          <Radio
            className={cx('QuestionContent__radioColor', {
              QuestionContent__radioColor_active: answer.is_answer_correct,
            })}
            checked={false}
            label={answer.name}
          />
        </div>
      );
    } else if (type === QuestionTypeEnum.MULTIPLE_POINT_RATING) {
      return (
        <div className={cx('QuestionContent__multiGroup')}>
          <Text className={cx('QuestionContent__multiGroupText')} size="s">
            {answer.name}
          </Text>
          <ChoiceGroup
            items={Array.from(Array(rating)).map((_, i) => i + 1)}
            getLabel={(item) => item}
            multiple={false}
            name="ChoiceMultiGroup"
            className={cx(
              'QuestionContent__choiseGroup',
              'QuestionContent__multiChoiseGroup',
            )}
          />
        </div>
      );
    } else {
      return (
        <div className={cx('QuestionContent__radio')}>
          <Checkbox
            className={cx('QuestionContent__radioColor', {
              QuestionContent__radioColor_active: answer.is_answer_correct,
            })}
            checked={false}
            label={answer.name}
          />
        </div>
      );
    }
  };

  const statusIndex = useMemo(() => {
    const newQuest = Object.values(open).some((item) => item);
    return newQuest;
  }, [open]);

  const handleChangeQuestion = useCallback(() => {
    let newOpen;
    if (statusIndex) {
      newOpen = Object.entries(open).map(([id]) => {
        return {
          id,
          isOpen: false,
        };
      });
    } else {
      newOpen = Object.entries(open).map(([id]) => {
        return {
          id,
          isOpen: true,
        };
      });
    }
    const objOpen = newOpen.reduce(
      (acc, item) => ({ ...acc, [item.id]: item.isOpen }),
      {},
    );
    setOpen(objOpen);
  }, [open, statusIndex]);

  if (!isLoadingListQuestion) return <Loader />;
  return (
    <div className={cx('QuestionContent', className)}>
      {allListQuestion.length === 0 ? (
        <Text className={cx('QuestionContent__notQuest')}>{NotQuestion}</Text>
      ) : (
        <div>
          <Button
            className={cx('QuestionContent__expand')}
            size="m"
            view="clear"
            label={statusIndex ? 'Свернуть все' : 'Развернуть все'}
            onClick={() => handleChangeQuestion()}
          />
          <DragDropContext
            onDragEnd={(param) => {
              const srcI = param.source.index;
              const desI = param.destination?.index;
              if (desI || desI === 0) {
                const newListQuest = [...listQuestion];
                newListQuest.splice(desI, 0, newListQuest.splice(srcI, 1)[0]);
                setListQuestion(newListQuest);
                setSave(true);
              }
            }}
          >
            <Droppable droppableId="droppable-1">
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {listQuestion.map((item: AllListQuestionDataEnt, index) => (
                    <Draggable
                      key={index}
                      draggableId={`draggable-${index}`}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          className={cx('QuestionContent__questions')}
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                        >
                          <div className={cx('QuestionContent__question')}>
                            <div className={cx('QuestionContent__row')}>
                              <IconArrowDown
                                className={cx('QuestionContent__arrow', {
                                  QuestionContent__arrow_active:
                                    open[item.id] === true,
                                })}
                                onClick={() => {
                                  setOpen({
                                    ...open,
                                    [item.id]: !open[item.id],
                                  });
                                }}
                              />

                              <Text
                                className={cx('QuestionContent__nameQuestion')}
                                size="m"
                              >
                                {item.is_required && (
                                  <span className={cx('QuestionContent__star')}>
                                    *
                                  </span>
                                )}
                                {`${index + 1}.${' '}${' '}${item.name}`}
                              </Text>
                            </div>
                            <div className={cx('QuestionContent__row')}>
                              <IconDraggable
                                {...provided.dragHandleProps}
                                className={cx('QuestionContent__drag', {
                                  QuestionContent__drag_hide:
                                    oneSurvey.status === SurveyStatusEnum.ENDED,
                                })}
                              />
                              <Button
                                className={cx('QuestionContent__edit')}
                                size="m"
                                view="clear"
                                iconRight={IconEdit}
                                onlyIcon
                                onClick={() => {
                                  setQuestion(true);
                                  setEditQuestion(item);
                                  addImagesIdle();
                                  deleteImageIdle();
                                }}
                              />
                              {oneSurvey.status !== SurveyStatusEnum.ENDED && (
                                <Button
                                  className={cx('QuestionContent__button')}
                                  size="m"
                                  view="clear"
                                  iconRight={IconTrash}
                                  onlyIcon
                                  onClick={() => {
                                    setModalCLose(true);
                                    setIdDeleteQuestion(item.id);
                                  }}
                                />
                              )}
                            </div>
                          </div>

                          <div
                            className={cx('QuestionContent__open', {
                              QuestionContent__open_active: open[item.id],
                            })}
                          >
                            <div className={cx('QuestionContent__imageDiv')}>
                              {item.images.map((image, i) => (
                                <img
                                  key={i}
                                  src={`${locationNotApi}${image?.path}`}
                                  className={cx('QuestionContent__image')}
                                />
                              ))}
                            </div>
                            <div className={cx('QuestionContent__answer')}>
                              {item.type === QuestionTypeEnum.POINT_RATING && (
                                <ChoiceGroup
                                  items={Array.from(Array(item.rating)).map(
                                    (_, i) => i + 1,
                                  )}
                                  getLabel={(item) => item}
                                  multiple={false}
                                  name=" ChoiceGroup"
                                  className={cx(
                                    'QuestionContent__choiseGroup',
                                    'QuestionContent__pointGroup',
                                  )}
                                />
                              )}
                              {item.answers.map((answer, ind: number) => (
                                <div
                                  className={cx('QuestionContent__rowRadio')}
                                  key={ind}
                                >
                                  {item.type !==
                                  QuestionTypeEnum.SELF_SELECT ? (
                                    questSelect(answer, item.type, item.rating)
                                  ) : (
                                    <div>
                                      <TextField
                                        className={cx(
                                          'QuestionContent__textFieldAnswer',
                                        )}
                                        value={answer.name}
                                        size="m"
                                        width="full"
                                        id={ind}
                                        disabled
                                      />
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>
                            <div className={cx('QuestionContent__export')}>
                              <Text
                                display="inline"
                                size="m"
                                view="secondary"
                                className={cx('QuestionContent__exportTest')}
                              >
                                {item.is_export
                                  ? 'Выгружается в отчет'
                                  : 'Не выгружается в отчет'}
                              </Text>

                              {testData.type === SurveyTypeEnum.TEST && (
                                <>
                                  <Text
                                    display="inline"
                                    size="m"
                                    view="secondary"
                                  >
                                    {`Количество баллов за вопрос:${' '}`}
                                  </Text>
                                  <span>{item.points}</span>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      )}
      <Modal isOpen={modalClose} hasOverlay>
        <CloseModal
          title={'Удалить вопрос'}
          text={DeleteQuestionTextModal}
          textButton={'Удалить'}
          iconClose={IconClose}
          handleClick={handleDelete}
          setModalOpenBlocking={setModalCLose}
        />
      </Modal>
    </div>
  );
};

const mapStateToProps = (state: State, props: any) => ({
  allListQuestion: allListQuestionIdSelector(state),
  isLoadingListQuestion: allListQuestionLoadedSelector(state, props),
});

const mapDispatchToProps = (dispatch: ThunkDispatch<State, void, Action>) => ({
  loadAllListQuestions: (id: number) => dispatch(loadAllListQuestions(id)),
  loadDeleteQuestion: (idSurvey: number, idQuestion: number) =>
    dispatch(loadDeleteQuestion(idSurvey, idQuestion)),
  addImagesIdle: () => dispatch(addImagesIdle()),
  deleteImageIdle: () => dispatch(deleteImageIdle()),
});

export default connect(mapStateToProps, mapDispatchToProps)(QuestionContent);
